import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * CeAssessmentProgress - Minimal progress indicator for CE assessment questions
 * 
 * Pixel-perfect port from Polymet prototype with succession theme variables.
 */
const CeAssessmentProgress = ({
  currentQuestion,
  totalQuestions,
  answeredCorrectly,
  className = '',
}) => {
  const intl = useIntl();
  const progressPercentage = (currentQuestion / totalQuestions) * 100;

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Label row: flex items-center justify-between text-sm */}
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-succession-text-secondary">
          {intl.formatMessage({ id: 'succession.plans.ce_progress_question_of' }, { current: currentQuestion, total: totalQuestions })}
        </span>
        {answeredCorrectly !== undefined && (
          <span className="text-xs text-succession-text-secondary">
            {intl.formatMessage({ id: 'succession.plans.ce_progress_correct' }, { count: answeredCorrectly })}
          </span>
        )}
      </div>
      {/* Progress bar: h-2 (8px) with 300ms transition */}
      <div className="h-2 w-full bg-succession-bg-secondary rounded-full overflow-hidden">
        <div
          className="h-full bg-succession-primary rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
};

CeAssessmentProgress.propTypes = {
  currentQuestion: PropTypes.number.isRequired,
  totalQuestions: PropTypes.number.isRequired,
  answeredCorrectly: PropTypes.number,
  className: PropTypes.string,
};

CeAssessmentProgress.defaultProps = {
  answeredCorrectly: undefined,
  className: '',
};

export default CeAssessmentProgress;

